<template>
  <div class="row" v-if="!roleSuperadmin">
    <div class="page-header d-flex justify-content-between align-items-center mb-4">
      <div>
        <h3 class="page-title text-white font-weight-bold mb-1">{{ $t('billing.title') }}</h3>
        <p class="text-muted small mb-0">{{ $t('billing.periodTitle') }}</p>
      </div>
    </div>

    <div class="col-sm-12 col-md-4 col-lg-4 grid-margin">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="stat-icon-badge bg-warning-soft text-warning p-2 rounded">
              <i class="mdi mdi-crown font-size-18"></i>
            </div>
            <h4 class="mb-0 text-white font-weight-bold">{{ $t('billing.periodTitle') }}</h4>
          </div>
          <hr class="border-secondary my-2" />
          <table class="table table-borderless py-0 my-0">
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.packageName') }}</th>
              <td class="text-end font-weight-bold text-white pe-0" v-if="!biling_information || !biling_information.billing || (biling_information1 && biling_information1.message == 'No data found')">
                -
              </td>
              <td class="text-end font-weight-bold text-warning pe-0" v-else>
                {{ (biling_information.billing.package && biling_information.billing.package.package_name) || '-' }}
              </td>
            </tr>
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.totalUsers') }}</th>
              <td class="text-end text-white pe-0" v-if="!biling_information || !biling_information.billing || (biling_information1 && biling_information1.message == 'No data found')">
                -
              </td>
              <td class="text-end font-weight-bold text-info pe-0" v-else>{{ total_adition() }} {{ $t('quota.seats') }}</td>
            </tr>
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.expiryDate') }}</th>
              <td class="text-end text-white pe-0" v-if="!biling_information || !biling_information.billing || (biling_information1 && biling_information1.message == 'No data found')">
                -
              </td>
              <td class="text-end text-light pe-0" v-else>
                {{ biling_information.billing.billing_period_end || '-' }}
              </td>
            </tr>
          </table>
          <div class="d-flex flex-column align-items-center justify-content-center mt-3 gap-2 w-100">
            <button
              class="btn btn-primary w-100 py-2 d-flex align-items-center justify-content-center gap-2"
              data-bs-toggle="modal"
              data-bs-target="#upgradeModal"
            >
              <i class="mdi mdi-arrow-up-bold-circle" aria-hidden="true"></i>
              <span>{{ $t('billing.upgradeNow') }}</span>
            </button>
            <!-- Modal -->
            <div
              class="modal fade"
              id="upgradeModal"
              tabindex="-1"
              aria-labelledby="upgradeModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content card card-glass text-white" style="background: #141724; border: 1px solid rgba(255,255,255,0.12); border-radius: 14px;">
                  <div class="modal-header border-secondary">
                    <h5 class="modal-title font-weight-bold text-white d-flex align-items-center gap-2" id="upgradeModalLabel">
                      <i class="mdi mdi-wallet-giftcard text-warning" aria-hidden="true"></i>
                      <span>{{ $t('billing.chooseExpansionTitle') }}</span>
                    </h5>
                    <button
                      type="button"
                      class="btn-close btn-close-white"
                      data-bs-dismiss="modal"
                      :aria-label="$t('billing.closeModal')"
                    ></button>
                  </div>
                  <div class="modal-body p-4">
                    <div class="row g-3">
                      <!-- Option 1: Add-on Seats -->
                      <div class="col-12">
                        <div class="p-3 rounded border border-warning" style="background: rgba(245, 158, 11, 0.08);">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="badge badge-warning text-dark font-weight-bold">
                              {{ $t('billing.addonOptionBadge') }}
                            </span>
                            <span class="text-warning small font-weight-bold">Rp {{ formatNumberOnly(29000) }} {{ $t('checkout.perSeatPerMonth') }}</span>
                          </div>
                          <h6 class="text-white font-weight-bold mb-1">
                            {{ $t('billing.addonOptionTitle') }}
                          </h6>
                          <p class="text-muted small mb-3">
                            {{ $t('billing.addonOptionDesc') }}
                          </p>
                          <router-link
                            :to="{ name: 'BillingPay', query: { mode: 'addon' } }"
                            class="btn btn-warning text-dark font-weight-bold btn-sm w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                            data-bs-dismiss="modal"
                          >
                            <i class="mdi mdi-account-plus" aria-hidden="true"></i>
                            <span>{{ $t('billing.buyAddonSeatsBtn') }}</span>
                          </router-link>
                        </div>
                      </div>

                      <!-- Option 2: Tier Upgrade -->
                      <div class="col-12">
                        <div class="p-3 rounded border border-info" style="background: rgba(6, 182, 212, 0.08);">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="badge badge-info font-weight-bold">
                              {{ $t('billing.tierOptionBadge') }}
                            </span>
                            <span class="text-info small font-weight-bold">{{ $t('billing.tierListLabel') }}</span>
                          </div>
                          <h6 class="text-white font-weight-bold mb-1">
                            {{ $t('billing.tierOptionTitle') }}
                          </h6>
                          <p class="text-muted small mb-3">
                            {{ $t('billing.tierOptionDesc') }}
                          </p>
                          <router-link
                            :to="{ name: 'BillingPay', query: { mode: 'package' } }"
                            class="btn btn-info text-white font-weight-bold btn-sm w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                            data-bs-dismiss="modal"
                          >
                            <i class="mdi mdi-arrow-up-bold-circle" aria-hidden="true"></i>
                            <span>{{ $t('billing.upgradeTierPlanBtn') }}</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer border-secondary justify-content-between">
                    <button
                      type="button"
                      class="btn btn-outline-secondary px-3"
                      data-bs-dismiss="modal"
                    >
                      {{ $t('billing.closeModal') }}
                    </button>
                    <a
                      href="mailto:support@gamiteam.app?subject=Gamiteam%20Plan%20Consultation"
                      class="btn btn-outline-light btn-sm"
                    >
                      <i class="mdi mdi-email-outline mr-1" aria-hidden="true"></i>
                      {{ $t('billing.contactSales') }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-4 col-lg-4 grid-margin">
      <div class="card h-100">
        <div class="card-body">
          <div class="d-flex align-items-center gap-2 mb-2">
            <div class="stat-icon-badge bg-info-soft text-info p-2 rounded">
              <i class="mdi mdi-calendar-clock font-size-18" aria-hidden="true"></i>
            </div>
            <h4 class="mb-0 text-white font-weight-bold">{{ $t('billing.billingInfo') }}</h4>
          </div>
          <hr class="border-secondary my-2" />
          <table class="table table-borderless py-0 my-0">
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.billingCycle') }}</th>
              <td class="text-end text-white pe-0" v-if="!biling_information || (biling_information1 && biling_information1.message == 'No data found')">
                1 {{ $t('billing.month') }}
              </td>
              <td class="text-end text-white pe-0" v-else>
                {{ biling_information.duration_in_month || "-" }} {{ $t('billing.month') }}
              </td>
            </tr>
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.nextBillingDate') }}</th>
              <td class="text-end text-white pe-0">
                {{ (biling_information && biling_information.billing && biling_information.billing.billing_period_end) ? formatDate(biling_information.billing.billing_period_end) : '-' }}
              </td>
            </tr>
            <tr>
              <th class="text-muted small ps-0">{{ $t('billing.status') }}</th>
              <td class="text-end pe-0">
                <span class="badge badge-outline-success font-weight-bold">{{ $t('billing.activeSubscriptionBadge') }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-4 col-lg-4 grid-margin">
      <div class="card h-100 border-warning-subtle" style="background: linear-gradient(145deg, rgba(255, 153, 0, 0.05) 0%, rgba(20, 24, 38, 0.95) 100%);">
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <div class="d-flex align-items-center gap-2">
                <div class="stat-icon-badge bg-warning-soft text-warning p-2 rounded">
                  <i class="mdi mdi-account-group-outline font-size-18" aria-hidden="true"></i>
                </div>
                <h4 class="mb-0 text-white font-weight-bold">{{ $t('billing.quotaCapacity') }}</h4>
              </div>
              <span class="badge badge-success font-weight-bold">{{ $t('billing.quotaHealthyBadge') }}</span>
            </div>
            <hr class="border-secondary my-2" />
            <div class="d-flex justify-content-between text-muted small mb-1">
              <span>{{ $t('billing.quotaUsage') }}</span>
              <span class="text-white font-weight-bold">{{ activePlayersCount }} / {{ total_adition() }} {{ $t('quota.seats') }}</span>
            </div>
            <div class="progress progress-sm bg-dark" style="height: 8px;">
              <div class="progress-bar bg-warning" role="progressbar" :style="{ width: seatUsagePercent + '%' }" :aria-valuenow="seatUsagePercent" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted d-block mt-2" style="font-size: 11px;">
              {{ $t('quota.seatsAvailableForOnboarding') }}
            </small>
          </div>
          <router-link
            :to="{ name: 'BillingPay', query: { mode: 'addon' } }"
            class="btn btn-warning text-dark font-weight-bold w-100 mt-3 py-2 d-flex align-items-center justify-content-center gap-2"
          >
            <i class="mdi mdi-plus-circle" aria-hidden="true"></i>
            <span>{{ $t('billing.quickAddQuota') }}</span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="card-title text-white mb-0">{{ $t('billing.historyTitle') }}</h4>
          </div>
          <div class="table-responsive">
            <table class="table align-middle">
              <thead>
                <tr>
                  <th>{{ $t('billing.payDate') }}</th>
                  <th>{{ $t('billing.billingPeriod') }}</th>
                  <th>{{ $t('billing.totalAmount') }}</th>
                  <th>{{ $t('billing.paymentType') }}</th>
                  <th>{{ $t('billing.paymentStatus') }}</th>
                  <th>{{ $t('billing.action') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in biling" :key="index">
                  <td class="text-muted small">{{ formatDate(data.billing_transaction ? data.billing_transaction.created_at : data.created_at) }}</td>
                  <td class="text-white small">
                    {{ formatDate(data.billing_period_start) }} -
                    {{ formatDate(data.billing_period_end) }}
                  </td>
                  <td>
                    <span class="font-weight-bold text-white">{{ formatPrice(data.billing_transaction ? data.billing_transaction.amount : 0) }}</span>
                  </td>
                  <td>
                    <span class="badge" :class="data.billing_transaction && data.billing_transaction.type === 'digital' ? 'badge-primary' : 'badge-secondary'">
                      {{ data.billing_transaction ? (data.billing_transaction.type === 'digital' ? $t('billing.digital') : $t('billing.manual')) : '-' }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="badge"
                      :class="{
                        'badge-warning': getStatus(data) === 'pending',
                        'badge-success': getStatus(data) === 'paid' || getStatus(data) === 'success',
                        'badge-danger': getStatus(data) === 'expired' || getStatus(data) === 'failed'
                      }"
                    >
                      {{ formatStatus(getStatus(data)) }}
                    </span>
                  </td>

                  <td class="text-right">
                    <div class="d-inline-flex flex-wrap justify-content-end align-items-center gap-1">
                      <a
                        v-if="
                          data.billing_transaction &&
                          getStatus(data) === 'pending' &&
                          data.billing_transaction.type == 'digital'
                        "
                        :href="data.billing_transaction.checkout_link"
                        class="btn btn-sm btn-info px-2"
                        target="_blank"
                        ><i class="mdi mdi-cash mr-1"></i>{{ $t('billing.payNow') }}</a
                      >
                      <a
                        v-if="
                          data.billing_transaction &&
                          getStatus(data) === 'pending' &&
                          data.billing_transaction.type == 'manual' &&
                          data.billing_transaction.amount_payment_proof == null
                        "
                        @click="paymanual(data)"
                        class="btn btn-sm btn-info px-2"
                        ><i class="mdi mdi-cash mr-1"></i>{{ $t('billing.payManual') }}</a
                      >
                      <button class="btn btn-sm btn-primary px-2" @click="openmodalstatus(data.id)">
                        <i class="mdi mdi-eye mr-1"></i>{{ $t('billing.viewDetail') }}
                      </button>
                      <a
                        v-if="data.billing_transaction && data.billing_transaction.invoice"
                        :href="data.billing_transaction.invoice"
                        class="btn btn-sm btn-outline-success px-2"
                        download
                        target="_blank"
                        :title="$t('billing.downloadInvoice')"
                        ><i class="mdi mdi-download mr-1"></i>PDF</a
                      >
                    </div>
                  </td>
                </tr>
                <tr v-if="!biling || biling.length === 0">
                  <td colspan="6" class="text-center py-5">
                    <EmptyState
                      icon="mdi-receipt-text-outline"
                      :title="$t('billing.noHistory')"
                      :description="$t('billing.noHistoryDesc')"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isModalstatus" class="custom-modal">
      <div class="custom-modal-content card" style="max-width: 600px; background: #12141c; border: 1px solid rgba(255,255,255,0.12); border-radius: 16px;">
        <div class="card-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <img width="110" src="../assets/images/logo-big.svg" alt="Gamiteam" />
            <span class="badge badge-outline-warning ml-2">{{ $t('billing.information') }}</span>
          </div>
          <button type="button" class="btn btn-sm btn-outline-secondary btn-icon" :aria-label="$t('billing.closeModal')" @click="closeModalStatus">
            <i class="mdi mdi-close" aria-hidden="true"></i>
          </button>
        </div>
        <div class="card-body p-4 text-white">
          <div class="row mb-3">
            <div class="col-5 text-muted small">{{ $t('billing.status') }}:</div>
            <div class="col-7">
              <template v-if="modal_status && (modal_status.billing_transaction || modal_status.status)">
                <span
                  class="badge badge-warning"
                  v-if="getStatus(modal_status) === 'pending'"
                  >{{ $t('billing.pending') }}</span
                >
                <span
                  class="badge badge-success"
                  v-if="getStatus(modal_status) === 'paid' || getStatus(modal_status) === 'success'"
                  >{{ $t('billing.paid') }}</span
                >
                <span
                  class="badge badge-danger"
                  v-if="getStatus(modal_status) === 'expired'"
                  >{{ $t('billing.expired') }}</span
                >
                <span
                  class="badge badge-danger"
                  v-if="getStatus(modal_status) === 'failed'"
                  >{{ $t('billing.failed') }}</span
                >
              </template>
              <span v-else class="text-muted">-</span>
            </div>
          </div>
          <div class="row mb-3" v-if="modal_status && modal_status.billing_transaction && modal_status.billing_transaction.reason_for_reject">
            <div class="col-5 text-muted small">{{ $t('billing.reasonForReject') }}:</div>
            <div class="col-7 text-danger font-weight-bold">
              {{ modal_status.billing_transaction.reason_for_reject }}
            </div>
          </div>
          <hr class="border-secondary my-3" />
          <div class="row mb-2">
            <div class="col-5 text-muted small">{{ $t('billing.packageName') }}:</div>
            <div class="col-7 font-weight-bold text-white">
              {{ (modal_status && modal_status.package && modal_status.package.package_name) || '-' }}
            </div>
          </div>
          <div class="row">
            <div class="col-5 text-muted small">{{ $t('checkout.pricePerUnit') }}:</div>
            <div class="col-7 font-weight-bold text-warning">
              {{ modal_status && modal_status.package ? formatPrice(modal_status.package.price_per_person_per_month) : '-' }}
            </div>
          </div>
        </div>
        <div class="card-footer border-secondary text-right">
          <button type="button" class="btn btn-secondary px-4" @click="closeModalStatus">
            {{ $t('billing.closeModal') }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row" v-else>
    <div class="col-12 mb-4">
      <h2 class="text-white font-weight-bold mb-1">{{ $t('nav.billingApprovals') }}</h2>
      <p class="text-muted small mb-0">{{ $t('superadmin.pendingBillingDesc') }}</p>
    </div>

    <div class="col-12 grid-margin">
      <div class="card">
        <div class="card-body">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div class="search-box" style="min-width: 320px; max-width: 440px; width: 100%;">
              <div class="input-group">
                <span class="input-group-text">
                  <i class="mdi mdi-magnify" aria-hidden="true"></i>
                </span>
                <input
                  v-model.trim="searchadmin"
                  type="text"
                  class="form-control"
                  :aria-label="$t('superadmin.searchInvoicesPlaceholder')"
                  :placeholder="$t('superadmin.searchInvoicesPlaceholder')"
                />
                <button v-if="searchadmin" class="btn btn-outline-secondary" type="button" :aria-label="$t('common.reset')" @click="searchadmin = ''; currentPage = 1">
                  <i class="mdi mdi-close" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="text-muted small">
              {{ $t('common.all') }}: <span class="text-white font-weight-medium">{{ filteredAdminItems.length }} {{ $t('superadmin.invoicesCountLabel') }}</span>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table align-middle" style="table-layout: fixed; width: 100%;">
              <thead>
                <tr>
                  <th style="width: 45px;">{{ $t('common.no') }}</th>
                  <th style="width: 240px;">{{ $t('superadmin.companyName') }} & {{ $t('superadmin.package') }}</th>
                  <th style="width: 200px;">{{ $t('superadmin.date') }} & {{ $t('superadmin.billingPeriod') }}</th>
                  <th style="width: 170px;">{{ $t('superadmin.amount') }}</th>
                  <th style="width: 180px;">{{ $t('common.status') }} & {{ $t('superadmin.paymentMethod') }}</th>
                  <th style="width: 130px; padding-right: 1rem;" class="text-right">{{ $t('common.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in paginationAdmin" :key="data.id">
                  <td class="text-muted">{{ index + 1 + (currentPage - 1) * itemsPerPage }}</td>
                  <td>
                    <div class="font-weight-semibold text-white text-truncate" :title="data.company ? data.company.name : '-'">
                      {{ data.company ? data.company.name : '-' }}
                    </div>
                    <div class="d-flex align-items-center gap-1 mt-1">
                      <span class="badge badge-outline-warning font-weight-medium">
                        {{ data.package ? data.package.package_name : '-' }}
                      </span>
                      <small class="text-muted text-truncate" style="max-width: 130px;" v-if="data.desc">
                        {{ data.desc }}
                      </small>
                    </div>
                  </td>
                  <td>
                    <div class="text-white small font-weight-medium">{{ formatDate(data.created_at) }}</div>
                    <small class="text-muted d-block text-truncate">
                      {{ formatDate(data.billing_period_start) }} - {{ formatDate(data.billing_period_end) }}
                    </small>
                  </td>
                  <td>
                    <div class="text-white font-weight-bold">
                      {{ formatPrice(data.billing_transaction ? data.billing_transaction.amount : 0) }}
                    </div>
                    <small class="text-muted">
                      <span class="badge badge-outline-secondary py-0 px-1">{{ data.duration }} {{ $t('billing.monthShort') }}</span>
                    </small>
                  </td>
                  <td>
                    <div class="d-flex flex-column gap-1 align-items-start">
                      <span
                        class="badge"
                        :class="{
                          'badge-warning': getStatus(data) === 'pending',
                          'badge-success': getStatus(data) === 'paid' || getStatus(data) === 'success',
                          'badge-danger': getStatus(data) === 'expired' || getStatus(data) === 'failed'
                        }"
                      >
                        {{ formatStatus(getStatus(data) || 'pending') }}
                      </span>
                      <span
                        class="badge"
                        :class="data.billing_transaction && data.billing_transaction.type === 'digital' ? 'badge-primary' : 'badge-secondary'"
                      >
                        {{ data.billing_transaction && data.billing_transaction.type === 'digital' ? $t('billing.onlineMethod') : $t('billing.bankTransferMethod') }}
                      </span>
                    </div>
                  </td>

                  <td class="text-right">
                    <div class="d-inline-flex align-items-center gap-1">
                      <button
                        class="btn btn-action-icon btn-outline-info"
                        @click="opendetail(data.id)"
                        :title="$t('common.view')"
                        :aria-label="$t('common.view')"
                      >
                        <i class="mdi mdi-eye" aria-hidden="true"></i>
                      </button>

                      <template v-if="getStatus(data) !== 'paid' && getStatus(data) !== 'success' && getStatus(data) !== 'failed' && getStatus(data) !== 'expired'">
                        <button
                          class="btn btn-action-icon btn-outline-success"
                          @click="approv(data.id)"
                          :title="$t('superadmin.approvePayment')"
                          :aria-label="$t('superadmin.approvePayment')"
                        >
                          <i class="mdi mdi-check" aria-hidden="true"></i>
                        </button>
                        <button
                          class="btn btn-action-icon btn-outline-danger"
                          @click="openreject(data.id)"
                          :title="$t('superadmin.rejectPayment')"
                          :aria-label="$t('superadmin.rejectPayment')"
                        >
                          <i class="mdi mdi-close" aria-hidden="true"></i>
                        </button>
                      </template>
                    </div>
                  </td>
                </tr>

                <tr v-if="paginationAdmin.length === 0">
                  <td colspan="6" class="text-center py-5">
                    <EmptyState
                      icon="mdi-receipt-text-outline"
                      :title="$t('superadmin.noPendingInvoices')"
                      :description="$t('superadmin.pendingBillingDesc')"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-if="filteredAdminItems.length > 0" class="mt-3">
            <PaginationComponents
              :totalItems="filteredAdminItems.length"
              :itemsPerPage="itemsPerPage"
              :currentPage="currentPage"
              @page-changed="onPageChanged"
            />
          </div>

          <!-- Detail Modal (Shadcn Zinc Dark) -->
          <div v-if="isModalOpen" class="custom-modal">
            <div class="custom-modal-content card" style="max-width: 650px; background: #12141c; border: 1px solid rgba(255,255,255,0.12); border-radius: 16px;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-receipt-text-outline text-primary mr-2" style="font-size: 22px;" aria-hidden="true"></i>
                  <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.invoiceVerificationDetail') }}</h5>
                </div>
                <button type="button" class="btn btn-sm btn-outline-secondary btn-icon" :aria-label="$t('billing.closeModal')" @click="closeModal">
                  <i class="mdi mdi-close" aria-hidden="true"></i>
                </button>
              </div>

              <div class="card-body p-4" v-if="bilingadmindetial && bilingadmindetial.billing_transaction">
                <!-- Company & Plan Row -->
                <div class="row mb-3">
                  <div class="col-6">
                    <div class="text-muted small text-uppercase font-weight-bold">{{ $t('superadmin.companyName') }}</div>
                    <div class="text-white font-weight-bold mt-1">
                      {{ (bilingadmindetial.company && bilingadmindetial.company.name) || '-' }}
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="text-muted small text-uppercase font-weight-bold">{{ $t('superadmin.package') }}</div>
                    <div class="text-warning font-weight-bold mt-1">
                      {{ (bilingadmindetial.package && bilingadmindetial.package.package_name) || '-' }}
                    </div>
                  </div>
                </div>

                <!-- Transaction Details Table -->
                <div class="p-3 rounded mb-4" style="background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.07); border-radius: 8px;">
                  <div class="row small mb-2">
                    <div class="col-6 text-muted">{{ $t('superadmin.invoiceNumber') }}:</div>
                    <div class="col-6 text-right text-white font-monospace">
                      {{ bilingadmindetial.billing_transaction.invoice_number || '-' }}
                    </div>
                  </div>
                  <div class="row small mb-2">
                    <div class="col-6 text-muted">{{ $t('superadmin.destinationBank') }}:</div>
                    <div class="col-6 text-right text-white">
                      {{ bilingadmindetial.billing_transaction.bank || '-' }} ({{ bilingadmindetial.billing_transaction.bank_account_name || '-' }})
                    </div>
                  </div>
                  <div class="row small mb-2">
                    <div class="col-6 text-muted">{{ $t('superadmin.baseAmount') }}:</div>
                    <div class="col-6 text-right text-white">
                      {{ formatPrice(bilingadmindetial.billing_transaction.amount) }}
                    </div>
                  </div>
                  <div class="row small mb-2" v-if="bilingadmindetial.billing_transaction.disc_amount">
                    <div class="col-6 text-muted">{{ $t('superadmin.discountVoucher') }}:</div>
                    <div class="col-6 text-right text-danger">
                      - {{ formatPrice(bilingadmindetial.billing_transaction.disc_amount) }}
                    </div>
                  </div>
                  <hr style="border-color: rgba(255,255,255,0.08);" class="my-2" />
                  <div class="row font-weight-bold">
                    <div class="col-6 text-white">{{ $t('superadmin.totalTransferAmount') }}:</div>
                    <div class="col-6 text-right text-success" style="font-size: 1.1rem;">
                      {{ formatPrice(total_amount()) }}
                    </div>
                  </div>
                </div>

                <!-- Payment Proof -->
                <div v-if="bilingadmindetial.billing_transaction.payment_proof">
                  <div class="text-muted small text-uppercase font-weight-bold mb-2">{{ $t('superadmin.paymentTransferSlip') }}</div>
                  <div class="rounded p-2 text-center" style="background: rgba(0,0,0,0.4); border: 1px solid rgba(255,255,255,0.08); border-radius: 8px;">
                    <img
                      :src="bilingadmindetial.billing_transaction.payment_proof"
                      :alt="$t('superadmin.paymentTransferSlip')"
                      style="max-width: 100%; max-height: 280px; object-fit: contain; border-radius: 6px;"
                    />
                  </div>
                </div>
              </div>

              <div class="card-footer d-flex justify-content-between align-items-center">
                <button type="button" class="btn btn-secondary" @click="closeModal">
                  {{ $t('common.back') }}
                </button>
                <div v-if="bilingadmindetial && getStatus(bilingadmindetial) === 'pending'" class="d-flex gap-2">
                  <button type="button" class="btn btn-outline-danger" @click="closeModal(); openreject(bilingadmindetial.id)">
                    <i class="mdi mdi-close mr-1" aria-hidden="true"></i> {{ $t('superadmin.rejectPayment') }}
                  </button>
                  <button type="button" class="btn btn-success" @click="closeModal(); approv(bilingadmindetial.id)">
                    <i class="mdi mdi-check mr-1" aria-hidden="true"></i> {{ $t('superadmin.approvePayment') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Reject Modal (Shadcn Zinc Dark) -->
          <div v-if="isModalOpenReject" class="custom-modal">
            <div class="custom-modal-content card" style="max-width: 500px; background: #12141c; border: 1px solid rgba(255,255,255,0.12); border-radius: 16px;">
              <div class="card-header d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-alert-circle-outline text-danger mr-2" style="font-size: 22px;" aria-hidden="true"></i>
                  <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.rejectPayment') }}</h5>
                </div>
                <button type="button" class="btn btn-sm btn-outline-secondary btn-icon" :aria-label="$t('billing.closeModal')" @click="closeModalReject">
                  <i class="mdi mdi-close" aria-hidden="true"></i>
                </button>
              </div>

              <div class="card-body p-4">
                <label for="rejectReasonTextarea" class="text-light small font-weight-bold mb-2">{{ $t('superadmin.rejectionReasonLabel') }} <span class="text-danger">*</span></label>
                <textarea
                  id="rejectReasonTextarea"
                  class="form-control"
                  v-model="reason_for_reject"
                  rows="4"
                  :placeholder="$t('superadmin.rejectionReasonPlaceholder')"
                  required
                ></textarea>
              </div>

              <div class="card-footer d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-secondary" @click="closeModalReject">
                  {{ $t('common.cancel') }}
                </button>
                <button type="button" class="btn btn-danger ml-2" @click="actionreject()">
                  <i class="mdi mdi-close-circle mr-1" aria-hidden="true"></i> {{ $t('superadmin.confirmRejection') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PaginationComponents from 'components/PaginationComponents.vue';
import PaginationComponents from "../components/PaginationComponents.vue";
import EmptyState from "../components/EmptyState.vue";
import { countPlayer } from "../services/dashboardService";
import moment from "moment";
import axios from "axios";
import config from "../config/config";
import store from "../store";
import Swal from "sweetalert2";

export default {
  name: "BillingView",
  components: {
    PaginationComponents,
    EmptyState,
  },
  data() {
    let isSuper = false;
    try {
      const raw = store.state.user || localStorage.getItem("user");
      if (raw) {
        let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (typeof parsed === "string") parsed = JSON.parse(parsed);
        const u = parsed?.data || parsed;
        const userRole = u?.role || '';
        const roles = userRole.split(',').map(r => r.trim().toLowerCase());
        isSuper = roles.includes('superadmin');
      }
    } catch (e) {
      isSuper = false;
    }

    return {
      companyOptions: [],
      transaction: [],
      biling_information: {},
      currentPage: 1,
      biling_information1: {},
      aditio: 0,
      limit: 0,
      activePlayersCount: 0,
      biling: [],
      bilingadmin: [],
      bilingadmindetial: [],
      searchadmin: "",
      search: "",
      itemsPerPage: 10,
      roleSuperadmin: isSuper,
      isModalOpen: false,
      reason_for_reject: "",
      billing_id: 0,
      isModalOpenReject: false,
      isModalstatus: false,
      modal_status: [],
      fetchDone: false,
      nama_package: "",
      discont: 0,
      amount: 0,
      remaining_package_disc: 0,

      invoice: sessionStorage.getItem("noinvoice"),
      amount_payment_proof: sessionStorage.getItem("amount"),
      payment_date: moment().format("YYYY-MM-DD"),

      billingpay_id: sessionStorage.getItem("billing_id"),
    };
  },
  methods: {
    async paymanual(data) {
      const API_URL = config.API_URL;
      const token = store.state.authToken || localStorage.getItem("authToken");
      const billingId =
        data?.billing_transaction?.billing_id ||
        data?.id ||
        this.billingpay_id;

      if (data?.billing_transaction?.invoice_number) {
        sessionStorage.setItem("noinvoice", data.billing_transaction.invoice_number);
      }
      if (data?.billing_transaction?.amount !== undefined) {
        sessionStorage.setItem("amount", data.billing_transaction.amount);
      }
      if (billingId) {
        sessionStorage.setItem("billing_id", billingId);
        this.billingpay_id = billingId;
      }

      let formData = new FormData();
      formData.append("billing_id", billingId);
      formData.append("type", "manual");
      formData.append("_method", "POST");

      try {
        await axios.post(`${API_URL}billing/select/payment-method`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        this.$router.push({ path: "/billing/detail" });
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: this.$t('common.error'),
          text: err.response?.data?.message || this.$t('billing.manualPaymentError'),
        });
      }
    },
    total_adition: function () {
      const add = parseInt(this.aditio) || 0;
      const lim = parseInt(this.limit) || 0;
      return add + lim;
    },
    getbilingInformation() {
      if (this.roleSuperadmin) return;
      const API_URL = config.API_URL;
      const token = store.state.authToken;

      let _ = this;
      axios
        .get(`${API_URL}subscription-package`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          const subData = Array.isArray(resp.data?.data) ? (resp.data.data[0] || {}) : (resp.data?.data || {});
          _.biling_information = subData;
          _.biling_information1 = resp.data || {};
          if (subData && subData.billing) {
            _.aditio = subData.billing.additional_user || 0;
            _.limit = (subData.billing.package && subData.billing.package.limit_user) || 0;
          } else {
            _.aditio = 0;
            _.limit = 0;
          }
        })
        .catch(() => {
          _.biling_information = {};
          _.biling_information1 = { message: "No data found" };
        });
    },
    total_amount: function () {
      return (
        parseInt(this.amount) -
        parseInt(this.discont) -
        parseInt(this.remaining_package_disc)
      );
    },
    openmodalstatus(id) {
      const API_URL = config.API_URL;
      const token = store.state.authToken;

      let _ = this;
      axios
        .get(`${API_URL}billing/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          _.modal_status = resp.data.data;
          this.isModalstatus = true;
        })
        .catch(() => {});
    },
    opendetail(id) {
      const API_URL = config.API_URL;
      const token = store.state.authToken;

      let _ = this;
      axios
        .get(`${API_URL}admin/billing/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          _.bilingadmindetial = resp.data.data;
          _.discont = resp.data.data.billing_transaction.disc_amount;
          _.remaining_package_disc =
            resp.data.data.billing_transaction.remaining_package_disc;
          _.amount = resp.data.data.billing_transaction.amount;
          this.isModalOpen = true;
        })
        .catch(() => {});
    },
    openreject(id) {
      const API_URL = config.API_URL;
      const token = store.state.authToken;

      let _ = this;
      axios
        .get(`${API_URL}admin/billing/detail/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          _.billing_id = resp.data.data.billing_transaction.billing_id;
          this.isModalOpenReject = true;
        })
        .catch(() => {});
    },
    approv(id) {
      const invoiceItem = (this.bilingadmin || []).find((x) => x.id === id);
      const invoiceNo = invoiceItem?.billing_transaction?.invoice_number || id;
      const companyName = invoiceItem?.company?.name || this.$t('superadmin.defaultClientName');

      Swal.fire({
        title: this.$t('superadmin.confirmApproveInvoiceTitle'),
        text: this.$t('superadmin.confirmActivationText', { invoice: invoiceNo, company: companyName }),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#10b981',
        cancelButtonColor: '#374151',
        confirmButtonText: this.$t('superadmin.confirmActivationBtn'),
        cancelButtonText: this.$t('common.cancel'),
        background: '#12141c',
        color: '#fff',
      }).then((result) => {
        if (result.isConfirmed) {
          const API_URL = config.API_URL;
          const token = store.state.authToken;

          axios
            .get(`${API_URL}admin/billing/approve/${id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(() => {
              Swal.fire({
                title: this.$t('common.success'),
                text: this.$t('superadmin.approveSuccessText', { invoice: invoiceNo }),
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
                background: '#12141c',
                color: '#fff',
              });
              this.getBilingAdmin();
            })
            .catch((err) => {
              Swal.fire({
                icon: 'error',
                title: this.$t('common.error'),
                text: err.response?.data?.message || this.$t('superadmin.approveInvoiceError'),
                confirmButtonColor: '#0090e7',
                background: '#12141c',
                color: '#fff',
              });
            });
        }
      });
    },
    actionreject() {
      if (!this.reason_for_reject || !this.reason_for_reject.trim()) {
        Swal.fire({
          icon: 'warning',
          title: this.$t('common.warning'),
          text: this.$t('superadmin.rejectionReasonPlaceholder'),
          background: '#12141c',
          color: '#fff',
        });
        return;
      }
      const API_URL = config.API_URL;
      const token = store.state.authToken;
      let formData = new FormData();
      formData.append("billing_id", this.billing_id);
      formData.append("reason_for_reject", this.reason_for_reject);
      formData.append("_method", "POST");

      axios
        .post(`${API_URL}admin/billing/reject`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.closeModalReject();
          this.reason_for_reject = "";
          Swal.fire({
            icon: "success",
            title: this.$t('common.success'),
            text: this.$t('superadmin.rejectSuccessText'),
            timer: 2000,
            showConfirmButton: false,
            background: '#12141c',
            color: '#fff',
          });
          this.getBilingAdmin();
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: this.$t('common.error'),
            text: err.response?.data?.message || this.$t('superadmin.rejectInvoiceError'),
            background: '#12141c',
            color: '#fff',
          });
        });
    },

    filteredItems() {
      const q = (this.search || "").toLowerCase();
      return (this.biling || []).filter((item) => {
        return (
          (item.billing_period_end || "").toLowerCase().indexOf(q) > -1 ||
          (item.status || item.billing_transaction?.status || "").toLowerCase().indexOf(q) > -1
        );
      });
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    closeModalReject() {
      this.isModalOpenReject = false;
    },
    closeModalStatus() {
      this.isModalstatus = false;
    },
    paginatedRedeem() {
      if (this.fetchDone) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.biling.slice(start, end);
      } else {
        return [];
      }
    },

    formatNumberOnly(value) {
      const intValue = parseInt(String(value ?? 0).replace(/[^\d-]/g, ""), 10) || 0;
      const localeTag = this.$currentLocale === "id" ? "id-ID" : "en-US";
      return intValue.toLocaleString(localeTag);
    },
    formatPrice(value) {
      return `Rp ${this.formatNumberOnly(value)}`;
    },
    formatDate(date) {
      if (!date) return "-";
      const parsed = new Date(date);
      if (!Number.isNaN(parsed.getTime())) {
        const localeTag = this.$currentLocale === "id" ? "id-ID" : "en-US";
        return parsed.toLocaleDateString(localeTag, {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
      }
      return moment(date).format("DD MMM YYYY");
    },
    detectRole() {
      try {
        const raw = store.state.user || localStorage.getItem("user");
        if (raw) {
          let parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
          if (typeof parsed === "string") parsed = JSON.parse(parsed);
          const u = parsed?.data || parsed;
          const userRole = u?.role || '';
          const roles = userRole.split(',').map(r => r.trim().toLowerCase());
          this.roleSuperadmin = roles.includes('superadmin');
        } else {
          this.roleSuperadmin = false;
        }
      } catch (e) {
        this.roleSuperadmin = false;
      }
      return this.roleSuperadmin;
    },
    getBiling() {
      if (this.roleSuperadmin) return;
      const API_URL = config.API_URL;
      const token = store.state.authToken || localStorage.getItem("authToken");

      let _ = this;
      axios
        .get(`${API_URL}billing`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          _.biling = resp.data?.data || [];
          _.fetchDone = true;
        })
        .catch((err) => {
          console.warn("Failed to fetch billing:", err?.response?.data || err.message);
          _.biling = [];
          _.fetchDone = true;
        });
    },
    onPageChanged(page) {
      this.currentPage = page;
    },
    getBilingAdmin() {
      if (!this.roleSuperadmin) return;
      const API_URL = config.API_URL;
      const token = store.state.authToken;

      let _ = this;
      axios
        .get(`${API_URL}admin/billing`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((resp) => {
          _.bilingadmin = resp.data?.data?.data || [];
          this.fetchDone = true;
        })
        .catch((err) => {
          console.warn("Failed to fetch admin billing:", err?.response?.data || err.message);
          this.fetchDone = true;
        });
    },
    getBilingAdminsearch() {
      this.currentPage = 1;
    },
    getStatus(item) {
      if (!item) return '';
      const status = item.billing_transaction?.status || item.status || '';
      return String(status).toLowerCase().trim();
    },
    formatStatus(raw) {
      if (!raw || raw === '-') return '-';
      const s = String(raw).toLowerCase().trim();
      if (s === 'paid' || s === 'success') return this.$t('billing.paid');
      if (s === 'pending') return this.$t('billing.pending');
      if (s === 'expired') return this.$t('billing.expired');
      if (s === 'failed') return this.$t('billing.failed');
      return raw;
    },
  },
  watch: {
    searchadmin() {
      this.currentPage = 1;
    },
  },
  async mounted() {
    this.detectRole();
    if (this.roleSuperadmin) {
      this.getBilingAdmin();
    } else {
      this.getbilingInformation();
      this.getBiling();
      countPlayer()
        .then((res) => {
          this.activePlayersCount = Number(res?.data?.data ?? res?.data ?? res ?? 0);
        })
        .catch(() => {
          this.activePlayersCount = 0;
        });
    }
  },
  computed: {
    seatUsagePercent() {
      const total = Number(this.total_adition()) || 0;
      if (total <= 0) return 0;
      return Math.min(100, Math.round((Number(this.activePlayersCount || 0) / total) * 100));
    },
    filteredAdminItems() {
      const list = this.bilingadmin || [];
      const q = (this.searchadmin || "").trim().toLowerCase();
      if (!q) return list;
      return list.filter((item) => {
        const companyName = (item.company?.name || "").toLowerCase();
        const pkgName = (item.package?.package_name || "").toLowerCase();
        const invoiceNo = (item.billing_transaction?.invoice_number || "").toLowerCase();
        const status = (item.billing_transaction?.status || "").toLowerCase();
        return (
          companyName.includes(q) ||
          pkgName.includes(q) ||
          invoiceNo.includes(q) ||
          status.includes(q)
        );
      });
    },
    paginationAdmin() {
      if (this.fetchDone) {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredAdminItems.slice(start, end);
      } else {
        return [];
      }
    },
  },
};
</script>
<style scoped>
.dropdown-menu > li > a:hover {
  background-image: none;
  background-color: #eee;
}
.btn-action-icon {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border-radius: 6px !important;
  font-size: 14px !important;
  line-height: 1 !important;
  transition: all 0.15s ease-in-out;
}
.btn-action-icon:hover {
  transform: translateY(-1px);
}
</style>
